import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { Container, Row, Col, Alert } from 'react-bootstrap'
import { Rocket } from 'lucide-react'
import ModelDeploymentView from '../ModelDeploymentView/ModelDeploymentView'
import { useAppSelector } from '../../../store/hooks'
import { selectSelectedProjectId } from '../../../store/slices/projectSlice'

const DeploymentView: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>()
  const navigate = useNavigate()
  const selectedProjectId = useAppSelector(selectSelectedProjectId)

  // Redirect to projects if no project selected
  React.useEffect(() => {
    if (!selectedProjectId && !projectId) {
      navigate('/projects')
    }
  }, [selectedProjectId, projectId, navigate])

  if (!selectedProjectId && !projectId) {
    return (
      <Container fluid>
        <Row>
          <Col>
            <Alert variant="warning">
              <Alert.Heading>No Project Selected</Alert.Heading>
              <p>Please select a project to view deployment options.</p>
            </Alert>
          </Col>
        </Row>
      </Container>
    )
  }

  return (
    <Container fluid>
      <Row>
        <Col>
          <ModelDeploymentView />
        </Col>
      </Row>
    </Container>
  )
}

export default DeploymentView
